import { useEffect, useState } from "react";
import { assignCategory } from "../../utils/api";
import Select from "../../utils/components/Select";

const ChooseCategory = ({
	comment,
	categories,
	year,
	weekNumber,
	setUpdatedValue,
}) => {
	const [selectedValue, setOptionSelectedValue] = useState("");

	useEffect(() => {
		if (selectedValue !== "") {
			assignCategory(comment.id, weekNumber, selectedValue, year)
				.then((updatedValue) => {
					if (updatedValue) {
						setUpdatedValue(updatedValue);
					}
				})
				.catch((error) => {
					// Handle error
				});
		}
	}, [selectedValue]);

	const filteredData = comment.week_data.filter(
		// eslint-disable-next-line eqeqeq
		(item) => item.week_no == weekNumber
	);

	return (
		<td>
			<Select
				data={categories}
				label={
					filteredData.length > 0 && filteredData[0].category
						? filteredData[0].category.name
						: ""
				}
				variant={""}
				bgColor={
					filteredData.length > 0 && filteredData[0].category
						? filteredData[0].category.color
						: "#cfcfcf"
				}
				textColor={
					filteredData.length > 0 && filteredData[0].category
						? filteredData[0].category.text_color
						: "#000"
				}
				onOptionSelect={setOptionSelectedValue}
			/>
		</td>
	);
};

export default ChooseCategory;
